import type { Locale } from '../../i18n/locales'
import type { KataId } from '../catalog/types'
import { itsutsuNoKataCriteriaI18n } from './locales/itsutsu-no-kata'
import { juNoKataCriteriaI18n } from './locales/ju-no-kata'
import { katameNoKataCriteriaI18n } from './locales/katame-no-kata'
import { kimeNoKataCriteriaI18n } from './locales/kime-no-kata'
import { kodokanGoshinJutsuCriteriaI18n } from './locales/kodokan-goshin-jutsu'
import { koshikiNoKataCriteriaI18n } from './locales/koshiki-no-kata'
import { nageNoKataCriteriaI18n } from './locales/nage-no-kata'
import type { ScoringCriterion } from './types'

/** Localized observation / hint copy keyed by criterion id. */
export type CriterionLocaleCopy = {
  text: string
  hint?: string
}

export type CriterionLocaleBundle = {
  ja?: Record<string, CriterionLocaleCopy>
  'zh-Hant'?: Record<string, CriterionLocaleCopy>
}

const bundles: Partial<Record<KataId, CriterionLocaleBundle>> = {
  'nage-no-kata': nageNoKataCriteriaI18n,
  'katame-no-kata': katameNoKataCriteriaI18n,
  'ju-no-kata': juNoKataCriteriaI18n,
  'kime-no-kata': kimeNoKataCriteriaI18n,
  'kodokan-goshin-jutsu': kodokanGoshinJutsuCriteriaI18n,
  'koshiki-no-kata': koshikiNoKataCriteriaI18n,
  'itsutsu-no-kata': itsutsuNoKataCriteriaI18n,
}

export type LocalizedCriterionCopy = {
  text: string
  hint?: string
  /** True when a non-English overlay was applied. */
  translated: boolean
}

/**
 * Resolve marking-scheme copy for the UI.
 * English remains the authoritative IJF transcription; other locales may use unofficial overlays.
 */
export function localizeCriterion(
  kataId: KataId,
  criterion: ScoringCriterion,
  locale: Locale,
): LocalizedCriterionCopy {
  if (locale === 'en') {
    return {
      text: criterion.text,
      hint: criterion.hint,
      translated: false,
    }
  }

  const overlay = bundles[kataId]?.[locale]?.[criterion.id]
  if (!overlay) {
    return {
      text: criterion.text,
      hint: criterion.hint,
      translated: false,
    }
  }

  return {
    text: overlay.text,
    hint: overlay.hint ?? criterion.hint,
    translated: true,
  }
}
